import { AddWebhookRequestType, WebhookStatusEnum } from '@interface/webhook/webhook.interface';

export const initialNewApplicationForm: Omit<AddWebhookRequestType, 'id'> = {
  application: '',
  description: '',
  unifiedApi: '',
  status: WebhookStatusEnum.Enabled,
  deliveryUrl: '',
  events: [],
};
